import { RequestContext } from '../../types/request-context';
import { StorefrontItemPlaybackAction } from './storefront';

export enum uxTreatment {
    DARK = "DARK",
    LIGHT = "LIGHT"
}

export interface EPGOutput {
    sections: EPGSection[];
    uiStrings: { [key: string]: string };
    timezoneStrings: { [key: string]: string };
    userLocale: string;
    formFactor: string;
    channelsBrowseLink: string;
}

export interface EPGSection {
    title?: string;
    channels: EPGChannel[];
    uxTreatment: uxTreatment;
}

export interface EPGChannel {
    channelName: string;
    logo?: string;
    lcid: string;
    link?: string;
    playbackAction?: StorefrontItemPlaybackAction;
    schedule: EPGItem[];
    pageAnchor?: string;
}

export interface EPGItem {
    titleID?: string;
    title?: string;
    link?: string;
    unixStart: number;
    unixEnd: number;
}

export interface EPGInput {
    context: RequestContext;
}
